import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

import { APIMS } from "../../../../../../config/apims";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";

import "bulma/css/bulma.css";
import "../../../../../../index.css";
// import "../../../../../../sims-ui.css";

export default function DataTingkatanAdd(
  props
) {
  const token =
    localStorage.getItem("token");

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const [loadingCabang, setLoadingCabang] =
    useState(false);

  const [
    loadingSekolah,
    setLoadingSekolah,
  ] = useState(false);

  const [
    getDataCabang,
    setGetDataCabang,
  ] = useState([]);

  const [getSekolah, setGetSekolah] =
    useState([]);

  const [form, setForm] = useState({
    name_level: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const getResponseCabang =
    useCallback(async () => {
      setLoadingCabang(true);

      try {
        const response = await APIMS.get(
          "/api/branches?page=1&limit=1000&ascending=1&search=",
          fetchParams
        );

        if (response?.status === 200) {
          setGetDataCabang(
            response?.data?.data || []
          );
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error.response?.data?.message ||
            "Gagal memuat data cabang",
        });
      } finally {
        setLoadingCabang(false);
      }
    }, [fetchParams]);

  const getResponseSekolah =
    useCallback(async () => {
      if (!form.ysb_branch_id) {
        setGetSekolah([]);
        return;
      }

      setLoadingSekolah(true);

      try {
        const response = await APIMS.get(
          `/api/schools?page=1&limit=1000&ascending=1&search=&branch=${form.ysb_branch_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetSekolah(
            response?.data?.data || []
          );
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error.response?.data?.message ||
            "Gagal memuat data sekolah",
        });
      } finally {
        setLoadingSekolah(false);
      }
    }, [
      fetchParams,
      form.ysb_branch_id,
    ]);

  useEffect(() => {
    if (props.show) {
      getResponseCabang();
    }
  }, [
    props.show,
    getResponseCabang,
  ]);

  useEffect(() => {
    getResponseSekolah();
  }, [getResponseSekolah]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,

      ...(name === "ysb_branch_id"
        ? {
            ysb_school_id: "",
          }
        : {}),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !form.name_level.trim() ||
      !form.ysb_branch_id ||
      !form.ysb_school_id
    ) {
      ToastError.fire({
        icon: "error",
        title: "Semua data wajib diisi",
      });

      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APIMS.post(
        "/api/grade-levels/store",
        {
          name_level:
            form.name_level.trim(),

          ysb_branch_id:
            form.ysb_branch_id,

          ysb_school_id:
            form.ysb_school_id,

          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Data berhasil ditambahkan",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error.response?.data?.message ||
          "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-tingkatan"
    >
      <form onSubmit={handleSubmit}>
        <Modal.Header className="sims-modal-header">
          <div>
            <h5 id="modal-tambah-tingkatan" className="sims-modal-title">
              Tambah Tingkatan
          </h5>
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon
              icon={faXmark}
            />
          </button>
        </Modal.Header>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">
            <div className="sims-form-group sims-form-span-2">
              <label
                className="sims-form-label"
                htmlFor="add-name-level"
              >
                Nama Tingkatan
                <span>*</span>
              </label>

              <input
                id="add-name-level"
                type="text"
                name="name_level"
                className="sims-form-input"
                value={form.name_level}
                onChange={handleChange}
                
                autoComplete="off"
                required
              />
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-branch"
              >
                Cabang
                <span>*</span>
              </label>

              <select
                id="add-branch"
                name="ysb_branch_id"
                className="sims-form-select"
                value={
                  form.ysb_branch_id
                }
                onChange={handleChange}
                disabled={loadingCabang}
                required
              >
                <option value="">
                  {loadingCabang
                    ? "Memuat cabang..."
                    : "Pilih Cabang"}
                </option>

                {getDataCabang.map(
                  (cabang) => (
                    <option
                      key={
                        cabang?.id ||
                        cabang?.branch_code
                      }
                      value={
                        cabang?.branch_code
                      }
                    >
                      {
                        cabang?.branch_name
                      }
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-school"
              >
                Sekolah
                <span>*</span>
              </label>

              <select
                id="add-school"
                name="ysb_school_id"
                className="sims-form-select"
                value={
                  form.ysb_school_id
                }
                onChange={handleChange}
                disabled={
                  !form.ysb_branch_id ||
                  loadingSekolah
                }
                required
              >
                <option value="">
                  {!form.ysb_branch_id
                    ? "Pilih Cabang terlebih dahulu"
                    : loadingSekolah
                    ? "Memuat sekolah..."
                    : "Pilih Sekolah"}
                </option>

                {getSekolah
                  .filter(
                    (school) =>
                      school?.school_code !==
                      "BASEMENT_BEKASI"
                  )
                  .map((school) => (
                    <option
                      key={
                        school?.id ||
                        school?.school_code
                      }
                      value={
                        school?.school_code
                      }
                    >
                      {
                        school?.school_name
                      }
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {/* {isSubmitting && (
              <span className="sims-button-spinner" />
            )}

            {isSubmitting
              ? "Menyimpan..."
              : "Tambahkan"} */}

            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                <span>Tambahkan</span>
              </>
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}